export default __webpack_public_path__ + "static/media/light.92036e19.svg";